import { Component, Input } from '@angular/core';

let nextId = 0;

// Bordered row with a label/description on the left and projected controls on the right.
// Reference labelId (via a template ref) for aria-labelledby on the row's controls.
@Component({
    selector: 'app-setting-row',
    templateUrl: './setting-row.component.html',
    styleUrl: './setting-row.component.scss'
})
export class SettingRowComponent {
  @Input({ required: true }) label = '';
  @Input() description = '';
  @Input() required = false;

  readonly labelId = `setting-row-label-${nextId++}`;
}
